import { ChevronDown, ChevronRight } from "lucide-react";
import type { TBookingPreview } from "./types";

interface BookingPreviewProps {
  booking: TBookingPreview;
  expanded: boolean;
  onToggleExpand: () => void;
}

export const BookingPreview = ({
  booking,
  expanded,
  onToggleExpand,
}: BookingPreviewProps) => {
  return (
    <div className="border rounded-lg overflow-hidden">
      <div
        className="p-4 bg-gray-50 flex justify-between items-center cursor-pointer"
        onClick={onToggleExpand}
      >
        <div className="flex items-center space-x-2">
          {expanded ? <ChevronDown size={20} /> : <ChevronRight size={20} />}
          <span className="font-medium">
            Selected Booking: {booking.referenceNumber}
          </span>
        </div>
        <div className="text-sm text-gray-500">
          {booking.client} | {booking.date}
        </div>
      </div>
      {expanded && (
        <div className="p-4 border-t">
          <div className="grid grid-cols-2 gap-6 mb-6">
            <div>
              <div className="text-sm text-gray-500 mb-1">Client</div>
              <div className="font-medium">{booking.client}</div>
            </div>
            <div>
              <div className="text-sm text-gray-500 mb-1">Project</div>
              <div className="font-medium">{booking.project}</div>
            </div>
          </div>
          <div className="mb-6">
            <div className="text-sm text-gray-500 mb-2">Services</div>
            <div className="space-y-2">
              {booking.services.map((service, index) => (
                <div
                  key={index}
                  className="p-2 bg-gray-50 rounded border flex justify-between"
                >
                  <span className="font-medium">{service.type}</span>
                  <span className="text-gray-600">{service.location}</span>
                </div>
              ))}
            </div>
          </div>
          <div>
            <div className="text-sm text-gray-500 mb-2">Inventory</div>
            <div className="border rounded overflow-hidden">
              <table className="w-full text-left">
                <thead className="bg-gray-50 text-sm">
                  <tr>
                    <th className="px-4 py-2">ID</th>
                    <th className="px-4 py-2">Title</th>
                    <th className="px-4 py-2">Dimensions</th>
                  </tr>
                </thead>
                <tbody className="divide-y">
                  {booking.inventory.map((item) => (
                    <tr key={item.id} className="text-sm">
                      <td className="px-4 py-2">{item.inventoryRef}</td>
                      <td className="px-4 py-2">{item.title}</td>
                      <td className="px-4 py-2">{item.dimensions}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
